var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-table-cell",
    { staticClass: "tx-history__cell" },
    [
      _c(
        "md-button",
        {
          ref: "copyBtn",
          attrs: { "data-clipboard-text": _vm.value },
          on: { click: _vm.showCopySuccess }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.valueToShow) + "\n    "),
          _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
            _vm._v(_vm._s(_vm.i18n.lbl_copy()))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f45c90e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f45c90e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/refundHistory/CopyVal.vue
// module id = uH3d
// module chunks = 1